export default __webpack_public_path__ + "static/media/ticket.163a28fa.svg";